<div class="pr-3  pl-4 h-full w-full flex flex-col" (window:resize)="onResize()">
  <div class="flex justify-between header-table" #pageOptionBtnGroup>
    <div class="title-page"><span class="title">Báo cáo thông tin nguồn nhân lực</span>
      <breadcrumbs [items]="breadcrumbs"></breadcrumbs>
    </div>
    <div class="btn-option flex">
      <ng-container *ngIf="btnType === buttonTypeEnum.ICON">
        <button nz-button class="flex items-center justify-center" nzTooltipTitle="Xuất excel"
          nzTooltipPlacement="bottom" nz-tooltip (click)="exportExcel()">
          <i nz-icon nzType="file-excel" nzTheme="twotone"></i>
        </button>
      </ng-container>
      <ng-container *ngIf="btnType === buttonTypeEnum.TEXT">
        <button nz-button class="flex items-center justify-center" (click)="exportExcel()">
          Xuất excel
        </button>
      </ng-container>
      <ng-container *ngIf="btnType === buttonTypeEnum.TEXTANDICON">
        <button nz-button class="flex items-center justify-center" (click)="exportExcel()">
          <i nz-icon nzType="file-excel" nzTheme="twotone"></i>
          Xuất excel
        </button>
      </ng-container>
    </div>
  </div>
  <form nz-form class="ant-advanced-search-form" #pageSearch>
    <div nz-row [nzGutter]="24">
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzRequired>Năm</nz-form-label>
          <nz-date-picker nzMode="year" [(ngModel)]="year" [ngModelOptions]="{standalone: true}"
            nzPlaceHolder="Nhập năm" (nzOnOpenChange)="changeYear()"></nz-date-picker>
        </nz-form-item>
      </div>
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24">Tỉnh thành</nz-form-label>
          <asc-autocomplete  [disabled]="isDisabled || isDisabled1 || isDisabled2"  [ascModel]="DisProvincesControl" (ascModelChange)="changeDisProvincesACFn($event)"
            placeholder="Chọn tỉnh thành..." [getListAC]="getDisProvincesACFn">
          </asc-autocomplete>
        </nz-form-item>
      </div>
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24">Quận huyện</nz-form-label>
          <asc-autocomplete [disabled]="isDisabled || isDisabled2" [ascModel]="DistrictControl" (ascModelChange)="changeDistrictACFn($event)"
            placeholder="Chọn quận huyện..." [getListAC]="getDistrictACFn">
          </asc-autocomplete>
        </nz-form-item>
      </div>

      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24">Cơ sở</nz-form-label>
          <asc-autocomplete [ascModel]="EducationSCHoolControl" [disabled]="isDisabled"
            [placeholder]="'Chọn cơ sở...'" [getListAC]="getEducationSCHooLACFn"></asc-autocomplete>
        </nz-form-item>
      </div>

      <ng-container *ngIf="isCollapse == false">

          <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
            <nz-form-item>
              <nz-form-label nzSpan="24">Phương thức giáo dục</nz-form-label>
              <asc-autocomplete [ascModel]="ModesOfEducationControl" (ascModelChange)="changeModesOfEducation($event)"
                placeholder="Chọn phương thức giáo dục..." [getListAC]="getModesOfEducationACFn">
              </asc-autocomplete>
            </nz-form-item>
          </div>

        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="ma">Mã nhân sự</nz-form-label>
            <nz-form-control nzSpan="24">
              <input nz-input [(ngModel)]="commonFilter.StaffCode" [ngModelOptions]="{standalone: true}"
                [placeholder]="'Nhập mã nhân sự...'" />
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="ma">Họ tên</nz-form-label>
            <nz-form-control nzSpan="24">
              <input nz-input [(ngModel)]="commonFilter.FullName" [ngModelOptions]="{standalone: true}"
                [placeholder]="'Nhập họ tên...'" />
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24">Giới tính</nz-form-label>
            <nz-form-control nzSpan="24">
              <nz-radio-group [(ngModel)]="commonFilter.Gender" [ngModelOptions]="{standalone: true}">
                <label nz-radio [nzValue]="1">Nam</label>
                <label nz-radio [nzValue]="0">Nữ</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24">Dân tộc</nz-form-label>
            <asc-autocomplete [ascModel]="FolkControl" (ascModelChange)="changeFolk($event)"
              placeholder="Chọn dân tộc..." [getListAC]="getFolkACFn">
            </asc-autocomplete>
          </nz-form-item>
        </div>

        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24">Loại nhân sự</nz-form-label>
            <asc-autocomplete [ascModel]="TypeOfPersonnalControl" (ascModelChange)="changeTypeOfPersonnel($event)"
              placeholder="Chọn cơ sở..." [getListAC]="getTypeOfPersonnalACFn">
            </asc-autocomplete>
          </nz-form-item>
        </div>

        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="ma">Năm sinh</nz-form-label>
            <nz-form-control nzSpan="24">
              <input nz-input [(ngModel)]="commonFilter.YearOfBirth" [ngModelOptions]="{standalone: true}"
                [placeholder]="'Nhập năm sinh...'" />
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24">Tình trạng làm việc</nz-form-label>
            <asc-autocomplete [ascModel]="EmploymentStatusControl" (ascModelChange)="changeEmploymentStatus($event)"
              placeholder="Chọn tình trạng làm việc..." [getListAC]="getEmploymentStatus">
            </asc-autocomplete>
          </nz-form-item>
        </div>

        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24">Trình độ đào tạo</nz-form-label>
            <asc-autocomplete [ascModel]="QualificationControl" (ascModelChange)="changeQualification($event)"
              placeholder="Chọn trình độ đào tạo..." [getListAC]="getQualification">
            </asc-autocomplete>
          </nz-form-item>
        </div>

        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24">Chuyên ngành đào tạo</nz-form-label>
            <asc-autocomplete [ascModel]="MajorControl" (ascModelChange)="changeMajor($event)"
              placeholder="Chọn chuyên ngành đào tạo..." [getListAC]="getMajorACFn">
            </asc-autocomplete>
          </nz-form-item>
        </div>

        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="ma">Số năm dạy học</nz-form-label>
            <nz-form-control nzSpan="24">
              <input nz-input [(ngModel)]="commonFilter.YearsOfService" [ngModelOptions]="{standalone: true}"
                [placeholder]="'Nhập số năm dạy học...'" />
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="ma">Số năm dạy học sinh khuyết tật</nz-form-label>
            <nz-form-control nzSpan="24">
              <input nz-input [(ngModel)]="commonFilter.YearsOfTeaching" [ngModelOptions]="{standalone: true}"
                [placeholder]="'Nhập số năm dạy học sinh khuyết tật...'" />
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24">Bồi dưỡng về giáo dục người khuyết tật</nz-form-label>
            <nz-form-control nzSpan="24">
              <nz-radio-group [(ngModel)]="commonFilter.StaffUnfostered" [ngModelOptions]="{standalone: true}">
                <label nz-radio [nzValue]="1">Có</label>
                <label nz-radio [nzValue]="0">Chưa</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
        </div>

      </ng-container>
      <div nz-col *ngIf="isCollapse" nzSpan="24">
        <div style="visibility: hidden; margin-top: 5px">i</div>
      </div>
    </div>
    <div nz-row>
      <div nz-col [nzSpan]="24" class="search-area">
        <button nz-button class="flex items-center justify-center" [nzTooltipTitle]="isCollapse ? 'Mở rộng' : 'Đóng'"
          nz-tooltip (click)="toggleCollapse()"><i nz-icon nzType="filter" nzTheme="outline"></i></button>
        <button nz-button class="flex items-center justify-center" (click)="clear()" nzTooltipTitle="Xóa tìm kiếm"
          nzTooltipPlacement="bottom" nz-tooltip><i nz-icon nzType="clear" nzTheme="outline"></i></button>
        <ng-container *ngIf="btnType === buttonTypeEnum.TEXT">
          <button nz-button class="flex items-center justify-center" [nzType]="'primary'" (click)="reload()">Tìm
            kiếm</button>
        </ng-container>
        <ng-container *ngIf="btnType === buttonTypeEnum.ICON">
          <button nz-button class="flex items-center justify-center" style="width: 100px;" [nzType]="'primary'"
            nzTooltipTitle="Tìm kiếm" nzTooltipPlacement="bottom" nz-tooltip (click)="reload()"><i nz-icon
              nzType="search" nzTheme="outline"></i></button>
        </ng-container>
        <ng-container *ngIf="btnType === buttonTypeEnum.TEXTANDICON">
          <button nz-button class="flex items-center justify-center" [nzType]="'primary'" (click)="reload()"><i nz-icon
              nzType="search" nzTheme="outline"></i>Tìm kiếm</button>
        </ng-container>
      </div>
    </div>
  </form>
  <div class="relative">
    <nz-table [nzShowTotal]="rangeTemplate" #Table nzOuterBordered nzShowSizeChanger [nzData]="dataTable" nzSize="small"
      [nzScroll]="{x: width +'px', y: height + 'px'}" class="absolute w-full" [nzFrontPagination]="false"
      [nzTotal]="Total" [nzPageSize]="pageSize" [nzPageIndex]="pageIndex" [nzPageSizeOptions]="pageSizeOptions"
      (nzPageIndexChange)="pageIndexEvent($event)" (nzPageSizeChange)="pageSizeEvent($event)">
      <thead>
        <tr #pageHeaderTable>
          <th nzWidth="25px" rowspan="2" nzLeft>STT
          </th>
          <th rowspan="2" nzWidth="50px" nzLeft>Mã nhân sự</th>
          <th rowspan="2" nzWidth="80px" nzLeft>Họ tên</th>
          <th rowspan="2" nzWidth="30px">Giới tính</th>
          <th rowspan="2" nzWidth="50px">Năm sinh</th>
          <th rowspan="2" nzWidth="50px">Dân tộc</th>
          <th rowspan="2" nzWidth="75px">Quốc tịch</th>
          <th rowspan="2" nzWidth="75px">Loại nhân sự</th>
          <th rowspan="2" nzWidth="75px">Vị trí công tác</th>
          <th rowspan="2" nzWidth="75px">Số năm làm quản lý tại đơn vị</th>
          <th rowspan="2" nzWidth="75px">Số năm công tác dạy học</th>
          <th rowspan="2" nzWidth="75px">Số năm dạy học người khuyết tật</th>
          <th rowspan="2" nzWidth="75px">Tình trạng việc làm</th>
          <th rowspan="2" nzWidth="75px">Loại hợp đồng</th>
          <th rowspan="2" nzWidth="75px">Trình độ đào tạo</th>
          <th rowspan="2" nzWidth="75px">Chuyên ngành đào tạo</th>
          <th rowspan="2" nzWidth="75px">Đào tạo/bồi dưỡng về giáo dục người khuyết tật(Có/chưa)</th>
          <th rowspan="2" nzWidth="75px">Đào tạo/bồi dưỡng về giáo dục người khuyết tật</th>
          <th rowspan="2" nzWidth="75px">Cơ sở giáo dục</th>

        </tr>

      </thead>
      <tbody>
        <tr *ngFor="let data of Table.data; let i = index">
          <td nzLeft>{{ i + 1 + (pageIndex-1)*pageSize }}</td>
          <td nzLeft>{{data.staffCode}}</td>
          <td nzLeft>{{data.fullName}}</td>
          <td>{{data.gender| gender}}</td>
          <td>{{data.yearOfBirth}}</td>
          <td>{{data.folkName}}</td>
          <td>{{data.nationalityName}}</td>
          <td>{{data.typeOfPersonnelName}}</td>
          <td>{{data.positionName}}</td>
          <td>{{data.yearManager}}</td>
          <td>{{data.yearsOfService}}</td>
          <td>{{data.yearsOfTeaching}}</td>
          <td>{{data.employmentStatusName}}</td>
          <td>{{data.contractTypeName}}</td>
          <td>{{data.qualificationName}}</td>
          <td>{{data.majorName}}</td>
          <td>{{data.staffUnfostered == false ? "Chưa" : "Có"}}</td>
          <td>{{data.disCertificateOfStaffs}}</td>
          <td>{{data.educationAndTrainingOrSchoolName}}</td>

        </tr>
      </tbody>
    </nz-table>
  </div>
</div>
<ng-keyboard-shortcuts [shortcuts]="shortcuts"></ng-keyboard-shortcuts>
<ng-template #rangeTemplate let-range="range" let-total> {{ range[0] }}-{{ range[1] }} của {{ Total }} </ng-template>
